import { useCallback, useState } from 'react';

export const useRecentlyAdded = () => {
  const [recentlyAdded, setRecentlyAdded] = useState<number[]>([]);

  const withRecentlyAddedTracking = useCallback(
    <Args extends any[]>(fn: (...args: Args) => Promise<number>) => {
      return async (...args: Args) => {
        const id = await fn(...args);
        setRecentlyAdded((prev) => (prev.includes(id) ? prev : [...prev, id]));
        return id;
      };
    },
    []
  );

  const wasRecentlyAdded = useCallback(
    (id: number) => recentlyAdded.includes(id),
    [recentlyAdded]
  );

  return {
    recentlyAdded,
    wasRecentlyAdded,
    withRecentlyAddedTracking,
  };
};
